import { Component } from '@angular/core';
import { AuthProvider } from "../../providers/auth/auth";
import { LandingPage } from '../../pages/landing/landing';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { StatBarComponent } from '../../components/stat-bar/stat-bar';
import { BeerEventsComponent } from '../../components/beer-events/beer-events';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HighestRatedBeersComponent } from '../../components/highest-rated-beers/highest-rated-beers';
import { LandingPage_PATH } from '../../app/app-constants';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  styleUrls: ['./home.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
//    NavBarComponent,
    StatBarComponent,
    BeerEventsComponent,
    HighestRatedBeersComponent
  ]
})
export class HomePage {
  public static PATH: string = 'home';

  constructor(
    public router: Router,
    private auth: AuthProvider,
  ) {
    this.log('constructed');
  }

  ionViewWillEnter() {
    this.log('ionViewWillEnter called');
    // this.userData.login('39a3ebe6-1f12-4895-af97-147ab9cf6f07');
    if (!this.auth.isLoggedInValue()) {
      this.router.navigate([ LandingPage_PATH ]);
    }
  }

  log(s: string) {
    //console.log((new Date()).toString() + ' - HomePage - ' + s);
  }
}
